import React from 'react';
import {steps} from "../constants";

export default class Passport extends React.Component {
    render() {
        if (this.props.currentStep !== steps.PASSPORT) {
            return null
        }
        
        return(
        <React.Fragment>
        <h2 className="subheading">UK Passport</h2>
        <p className="subtext">Do you hold a valid UK passport?</p>
        <div className="formContentWrapper">
            <div className="buttonWrapper justified">
                {Object.keys(this.props.passportOptions).map((item, index) =>
                <div className="optionButtonWrapper" key={item}>
                    <input
                    type="radio"
                    name="passport"
                    value={item}
                    id={item}
                    className="optionButtonInput"
                    checked={this.props.passport === item}
                    onChange={this.props.handleChange}
                    />
                    <label className="optionButton" htmlFor={item}>
                        {this.props.passportOptions[item]}
                    </label>
                </div>
                )}
            </div>
        </div>
        </React.Fragment>
        );
    }
}